// extracted by mini-css-extract-plugin
export default {"asterisk":"asterisk---Mr5jx","hasError":"hasError---PC18G"};